import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandlerFn,
    HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable, catchError, firstValueFrom } from 'rxjs';
import { HandleErrorService } from 'app/core/error/handle-error.service';
import { OfflineDetectionService } from 'app/core/services/offline-detection.service';

/**
 * Intercept
 *
 * @param req
 * @param next
 */
export const globalErrorInterceptor = (
    req: HttpRequest<any>,
    next: HttpHandlerFn
): Observable<HttpEvent<any>> => {
    const handleErrorService = inject(HandleErrorService);
    const offlineService = inject(OfflineDetectionService);

    // Response
    return next(req).pipe(
        catchError(async (error: HttpErrorResponse) => {
            // Check if offline - if so, don't show error notification
            const isOnline = await firstValueFrom(offlineService.isOnline$);

            if (isOnline) {
                handleErrorService.handleError(error);
            }
            // Rethrow the error to propagate it to the calling code
            throw error;
        })
    );
};
